// extracted by mini-css-extract-plugin
export default {"link":"link_link__E+Q+P","linkButton":"link_linkButton__Uv5sY","linkButtonPrimary":"link_linkButtonPrimary__KvSLn","linkBoxed":"link_linkBoxed__5+lUQ","small":"link_small__tk93e"};